import { LegalLayout, LegalSection } from "@/components/landing/LegalLayout";
import { EMAIL, EMAIL_MAILTO } from "@/constants/site";

export default function PolitiqueConfidentialite() {
    return (
        <LegalLayout title="Politique de confidentialité" testid="legal-privacy-page">
            <LegalSection title="Responsable du traitement">
                <p>
                    Pare Brise Paris est responsable du traitement des données personnelles
                    collectées dans le cadre de son activité de remplacement et de réparation de
                    pare-brise à domicile.
                </p>
            </LegalSection>

            <LegalSection title="Données collectées">
                <p>
                    Ce site ne contient aucun formulaire de collecte. Lorsque vous nous contactez
                    directement par téléphone, WhatsApp ou email, nous sommes amenés à recueillir :
                </p>
                <ul className="list-disc pl-5 space-y-1.5">
                    <li>Votre nom et vos coordonnées (téléphone, email)</li>
                    <li>Les informations relatives à votre véhicule (carte grise, modèle)</li>
                    <li>Vos documents d'assurance (mémo d'assuré ou attestation)</li>
                    <li>Votre adresse d'intervention (domicile ou lieu de travail)</li>
                </ul>
            </LegalSection>

            <LegalSection title="Finalités du traitement">
                <p>Vos données sont utilisées exclusivement pour :</p>
                <ul className="list-disc pl-5 space-y-1.5">
                    <li>Établir votre devis et planifier l'intervention</li>
                    <li>Réaliser les démarches auprès de votre compagnie d'assurance</li>
                    <li>Assurer le suivi de votre dossier et la garantie de la pose</li>
                </ul>
            </LegalSection>

            <LegalSection title="Base légale et durée de conservation">
                <p>
                    Le traitement repose sur l'exécution du contrat de prestation et sur notre
                    intérêt légitime à assurer le suivi client. Vos données sont conservées pendant
                    la durée nécessaire à la gestion de votre dossier, puis archivées conformément
                    aux obligations légales.
                </p>
            </LegalSection>

            <LegalSection title="Partage des données">
                <p>
                    Vos données ne sont transmises qu'à votre compagnie d'assurance dans le cadre de
                    la prise en charge de votre sinistre. Elles ne sont ni vendues ni cédées à des
                    tiers à des fins commerciales.
                </p>
            </LegalSection>

            <LegalSection title="Vos droits">
                <p>
                    Conformément au Règlement Général sur la Protection des Données (RGPD) et à la
                    loi Informatique et Libertés, vous disposez d'un droit d'accès, de
                    rectification, d'effacement, de limitation, d'opposition et de portabilité de
                    vos données.
                </p>
                <p>
                    Pour exercer ces droits, contactez-nous à :{" "}
                    <a href={EMAIL_MAILTO} className="text-gold-dark font-medium hover:underline">
                        {EMAIL}
                    </a>
                    . Vous pouvez également introduire une réclamation auprès de la CNIL
                    (www.cnil.fr).
                </p>
            </LegalSection>

            <LegalSection title="Cookies">
                <p>
                    Ce site n'utilise aucun cookie publicitaire ou de mesure d'audience. Aucune
                    donnée de navigation n'est exploitée à des fins commerciales.
                </p>
            </LegalSection>

            <LegalSection title="Sécurité">
                <p>
                    Nous mettons en œuvre les mesures techniques et organisationnelles appropriées
                    pour protéger vos données contre tout accès, perte, altération ou divulgation
                    non autorisés.
                </p>
            </LegalSection>

            <LegalSection title="Modifications">
                <p>
                    La présente politique peut être mise à jour à tout moment. La version en vigueur
                    est celle publiée sur cette page.
                </p>
            </LegalSection>
        </LegalLayout>
    );
}
